import React, { useState, useContext, memo, Suspense } from 'react'
import { Link } from 'react-router-dom'
// import ProductMainMenu from './CategoryMenu/CategoryMenu'
import PropTypes from 'prop-types'
import './MobileMenu.scss'
import { FiUser } from 'react-icons/fi'
import { FaAngleRight, FaUserTie } from 'react-icons/fa'
import { IoClose } from 'react-icons/io5'
import { LoaderContext, ScrollContext } from '../../../Routes/Routes'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { DeleteData } from '../../../helpers/apiHandler'
import toastr from 'toastr'
import { useDispatch } from 'react-redux'
import { deleteUser } from '../../../redux/actions/authActions'

const ProductMainMenu = React.lazy(() => import('./CategoryMenu/CategoryMenu'))

const MobileMenu = (props) => {
  const dispatch = useDispatch()
  const {setLoader } = useContext(LoaderContext);
const isMasterCustomer = JSON.parse(localStorage?.getItem('profile'))?.isMasterCustomer
  const [productMenu, setProductMenu] = useState(false)
  const { scrollState, setScrollState } = useContext(ScrollContext)

  const showProductMenu = (e, val) => {
    val !== false && props.showMobileMenuOne(e)
    setProductMenu(prevState => !prevState)
    if (scrollState.menuTwo) {
      setScrollState(prevState => ({ ...prevState, menuTwo: false }))
    } else setScrollState(prevState => ({ ...prevState, menuTwo: true }))
  }

  const manageLogout = e => {
    e.preventDefault()
    setLoader(true)
    DeleteData("customer/logout").then((response) => {
      setLoader(false)
      if (response.status === true) {
        toastr.success(response?.message, 'Success')
        dispatch(deleteUser())
        localStorage.removeItem('redirectToOrderCSV')
        localStorage.removeItem('profile')
        localStorage.removeItem('token')
        localStorage.removeItem('selectedLocation')
        localStorage.removeItem('masterAccessToken')
        setTimeout(() => {
          window.location = '/'
        }, 200)
      } else {
        toastr.error(response?.message, 'Error')
      }
    })
  }

  return (
        <div className='d-block'>
            <Suspense fallback={<div></div>}>
                <ProductMainMenu productMenu={productMenu} showProductMenu={showProductMenu} />
            </Suspense>
            <div className={props.mobileMenuOne ? 'mobile_menu1 open' : 'mobile_menu1'}>
                <div className="menu_header_close d-flex justify-content-end" style={isMasterCustomer ? {background: 'antiquewhite'} : undefined}>
                    <span className="closeMenu" role="button" onClick={props.showMobileMenuOne}>
                       <IoClose />
                    </span>
                </div>

                <div className="login-register d-flex justify-content-start align-items-center" style={isMasterCustomer ? {background: 'antiquewhite'} : undefined}>
                    {props.name
                      ? <><div><span style={{width: "40px", height: "40px", display: 'flex', justifyContent: 'center', alignItems: 'center'}} className="rounded-circle bg-secondary p-2 mr-2 text-white">
                      {props.name.split(' ')[0].charAt(0).toUpperCase()}{props.name.split(' ')[1].charAt(0).toUpperCase()}
                    </span></div><div className='d-flex flex-column'><span className="header-location">Hello,</span> {props.name}</div>
                    {isMasterCustomer && (
                                    <span 
                                      className="ml-2 d-flex align-items-center" 
                                      title="Master Account"
                                      style={{ padding: '4px 8px' }}
                                    >
                                      <FaUserTie style={{ fontSize: '14px' }} />
                                    </span>
                                  )}
                    </>
                      : <div className='d-flex align-items-center'>
                        <Link to='/login' className='mr-2'>
                            <span className="login_register d-flex align-items-center">
                                <FiUser className='header-user-icon'/>
                                <span>Login</span>
                            </span>
                        </Link>
                        <span>/</span>
                        <Link to='/register' className='ml-2'>
                            <span className="login_register">
                                Register
                            </span>
                        </Link>
                    </div>
                    }
                </div>
                <div className="home d-flex justify-content-start" onClick={props.showMobileMenuOne}>
                    <Link to="/" style={{ color: '#655b5c' }}>
                        <span className="home_heading">Home</span>
                    </Link>
                </div>

                <div className="second_menu d-flex justify-content-start flex-column">
                    <span className="submenu_heading d-flex justify-content-between" role="button" onClick={showProductMenu}>
                        Product Categories
                        <span>
                            <FaAngleRight className='h5 m-0'/>
                        </span>
                    </span>

                    <span className="normal_heading" onClick={props.showMobileMenuOne}>
                        <Link to="/about-us" style={{ color: '#655b5c' }}>
                        Why QLS
                        </Link>
                    </span>

                    <span className="normal_heading" onClick={props.showMobileMenuOne}>
                        <Link to='/industry-links' style={{ color: '#655b5c' }}>
                        Resources
                        </Link>
                    </span>

                    <span className="normal_heading" onClick={props.showMobileMenuOne}>
                        <Link to='/contact-us'style={{ color: '#655b5c' }}>
                        Contact Us
                        </Link>
                    </span>

                    <span className="normal_heading">
                    <span onClick={e => props.showMobileMenuOne(e, '', 'all-products')} style={{ color: '#655b5c' }}>
                        <Link to='/all-products' style={{ color: '#655b5c' }}>
                        All Products
                        </Link>
                        </span>
                    </span>
                </div>
                    {

                        props.name &&
                        <>
                <div className="second_menu_third d-flex justify-content-start flex-column">
                    <span className="submenu_heading">
                        My Account
                    </span>

                    <span className="normal_heading">
                    {props.name
                      ? <span onClick={props.showMobileMenuOne}><Link to='/orders'style={{ color: '#655b5c' }}>
                        Order History
                        </Link>
                        </span>
                      : <span><Link to='/'style={{ color: '#655b5c' }}>
                        Order History
                        </Link>
                        </span>
                        }
                    </span>

                    <span className="normal_heading">
                    {props.name
                      ? <span onClick={props.showMobileMenuOne}><Link to='/preferred-products'style={{ color: '#655b5c' }}>
                        Preferred Products
                        </Link>
                        </span>
                      : <span onClick={props.showMobileMenuOne}><Link to='/'style={{ color: '#655b5c' }}>
                        Preferred Products
                        </Link>
                        </span>
                    }
                    </span>
                </div>
                <hr className='logout-mobile'></hr>
                </>
                }
                <div className="second_menu_third d-flex justify-content-start flex-column ">
                <span className="submenu_heading" onClick={manageLogout}>
                {props.name ? 'Logout' : null}

                    </span>
                </div>

                <div className="download d-flex justify-content-start flex-column">
                    <span className="download_heading">
                        DOWNLOAD THE APP
                    </span>

                    <span className="icons_download mt-3 d-flex justify-content-start flex-row" style={{ marginBottom: '40px' }}>
                        <LazyLoadImage alt={'ios-image'}
                                        effect="blur"
                                        src={'/image/ios-button (1).png'}/>
                        <LazyLoadImage alt={'ios-image'}
                                        effect="blur"
                                        src={'/image/android-button (1).png'}
                                        className="ml-2"/>
                    </span>
                </div>
            </div>
        </div>
  )
}

MobileMenu.propTypes = {
  name: PropTypes.any,
  showMobileMenuOne: PropTypes.any,
  mobileMenuOne: PropTypes.any
}

export default memo(MobileMenu)
